/* Same for prerenderSlides
  prerenderSlides = [{
            large: require('/public/images/rtic/pdp/ultra-light/featured-image.jpg'),
            medium: require('/public/images/rtic/pdp/ultra-light/featured-image.jpg'),
            thumb: require('/public/images/rtic/pdp/ultra-light/featured-image.jpg'),
          }]
*/

import { ProductTypeId } from '@types';

export const getPDPV2Data = (type) => {
  switch (type) {
    case ProductTypeId.ROAD_TRIP_ROLLING_DUFFLE:
      return {
        tagline: 'Durably built to fit all your gear.',
        variants: {
          size: {
            Medium: {
              tagline: 'Fits in overhead bins',
            },
          },
        },
        prependSlides: [],
      };

    case ProductTypeId.TUMBLER_TYPE:
    case ProductTypeId.ANYWHERE_BLANKET:
    case ProductTypeId.EVERYDAY_INSULATED_TOTE:
    case ProductTypeId.HARD_COOLER_65_QT_TYPE:
    case ProductTypeId.HARD_COOLER_145_QT_TYPE:
    case ProductTypeId.PULLOVER_HOODIE_TYPE:
    case ProductTypeId.PULLOVER_HOODIE_RELAXED:
    case ProductTypeId.MENS_FULL_ZIP_HOODIE:
    case ProductTypeId.MENS_R_TECH_SUN_HOODIE:
    case ProductTypeId.MENS_R_TECH_PERFORMANCE_TEES:
    case ProductTypeId.RTIC_SHORT_SLEEVE_TSHIRT:
    case ProductTypeId.WOMENS_FULL_ZIP_HOODIE:
    case ProductTypeId.WOMENS_R_TECH_SUN_HOODIE:
    case ProductTypeId.WOMENS_R_TECH_PERFORMANCE_TEES:
    case ProductTypeId.CAN_CHILLER:
    case ProductTypeId.BOTTLE_CHILLER:
    case ProductTypeId.CHILLOUT_BACKPACK_COOLER:
    case ProductTypeId.EVERYDAY_COOLER:
    case ProductTypeId.ULTRA_TOUGH_TOTE:
    case ProductTypeId.ROAD_TRIP_DUFFLE:
    case ProductTypeId.ROAD_TRIP_BACKPACK:
    case ProductTypeId.ULTRA_TOUGH_WAGON:
    default:
      return {
        prependSlides: [],
        featureCards: {
          title: '',
          items: [],
        },
      };
  }
};
